import { BULLET_CHARACTER } from "@particles/Bullet/Bullet"

interface ClientLocationSource {
    client_name: string
    service_location_name: string
    service_location_address: string
}

// Secondary body line, e.g. "McDonald's ・ San Francisco, CA 98765", dropping empty segments.
export function composeClientLocation(object: ClientLocationSource): string {
    return [object.client_name, object.service_location_address || object.service_location_name]
        .filter(Boolean)
        .join(` ${BULLET_CHARACTER} `)
}

// Whether an attribute badge is selected in the cards-view settings. Without settings every
// attribute with data is rendered. The key must be one of the card's attribute names.
export function shouldShowAttribute<AttributeName extends string>(
    displayedAttributes: AttributeName[] | undefined,
    key: NoInfer<AttributeName>,
): boolean {
    return !displayedAttributes || displayedAttributes.includes(key)
}
